import {createContext, useContext} from "react"
import {HoursApi, IHoursApi} from "./api/hours-api"
import {Settings} from "./settings"
import {IProjectsApi, ProjectsApi} from "./api/projects-api"
import {IInsightApi, InsightApi} from "./api/insight-api"
import {CategoryApi, ICategoryApi} from "./api/category-api"
import {ITransactionsApi, TransactionsApi} from "./api/transactions-api"
import {IRulesApi, RulesApi} from "./api/rules-api"
import {AuthenticationService, IAuthenticationService} from "./authentication/authentication-service"
import {LoggedInUser} from "./authentication/user-context"
import {IRegistrationApi, RegistrationApi} from "./api/registration-api"
import {IImprovementsApi, ImprovementsApi} from "./api/improvements-api"

export const ServiceContext = createContext<IServices | null>(null)

export function useServices(): IServices | null {
  return useContext(ServiceContext)
}

export interface IServices {
  categoryApi: ICategoryApi
  hoursApi: IHoursApi
  projectsApi: IProjectsApi
  improvementsApi: IImprovementsApi
  insightApi: IInsightApi
  registrationApi: IRegistrationApi
  rulesApi: IRulesApi
  transactionsApi: ITransactionsApi
  authenticationService: IAuthenticationService
}

export const getServices = (settings: Settings, onUserChanged: (user: LoggedInUser) => void): IServices => {
  return {
    categoryApi: new CategoryApi(settings.greenUpBaseUrl),
    hoursApi: new HoursApi(settings.baseUrl),
    projectsApi: new ProjectsApi(settings.baseUrl),
    improvementsApi: new ImprovementsApi(settings.greenUpBaseUrl),
    insightApi: new InsightApi(settings.greenUpBaseUrl),
    registrationApi: new RegistrationApi(settings.greenUpBaseUrl),
    rulesApi: new RulesApi(settings.greenUpBaseUrl),
    transactionsApi: new TransactionsApi(settings.greenUpBaseUrl),
    authenticationService: new AuthenticationService(settings.greenUpBaseUrl, onUserChanged)
  }
}
